<template>
  <div>
    <!-- <div v-if="currentUrl.includes('bigul.stockants.com') || currentUrl.includes('http://localhost:8080/')"> -->
    <!-- // currentUrl.includes('choice.stockants.com') || -->

    <div
      v-if="
        currentUrl.includes('bigul.stockants.com') ||
          currentUrl.includes('maitracommodities.stockants.com') || 
          currentUrl.includes('ashlarindia-trade.stockants.com') || 
          currentUrl.includes('multigain-trade.stockants.com') || 
          currentUrl.includes('tradeplus.stockants.com') ||
          currentUrl.includes('sscorp.stockants.com') || 
          currentUrl.includes('skicapital.stockants.com')
      "
    >
      <BigulLoginPageVue></BigulLoginPageVue>
    </div>
    <div
      v-else-if="currentEnvironment && currentEnvironment.byPassLogin"
      style="
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;"
    >
      <div v-loading="is_login_page_loading"></div>
    </div>
    <div v-else>
      <Login></Login>
    </div>
  </div>
</template>
<script>
import BigulLoginPageVue from "./BigulLoginPage.vue";
import Login from "./Login.vue";
import { HelperNetworkCallBack } from "../mixins/Helper";
export default {
  name: "MainLoginPage",
  mixins: [HelperNetworkCallBack],
  components: { Login, BigulLoginPageVue },
  data() {
    return {
      currentUrl: "",
      currentEnvironment: {},
      is_login_page_loading: false,
    };
  },

  created() {},

  mounted() {
    // after logout save currentUrl
    if (!localStorage.getItem("currentUrl")) {
      this.selectUserType();
    }

    this.currentUrl = localStorage.getItem("currentUrl")
      ? localStorage.getItem("currentUrl")
      : window.location.href;

    if (localStorage.getItem("currentEnvironment")) {
      this.currentEnvironment = JSON.parse(
        localStorage.getItem("currentEnvironment")
      );
      if (this.currentEnvironment.byPassLogin) {
        this.is_login_page_loading = true;
        this.$router.push('/auth-bypass')
      } else {
        this.is_login_page_loading = false;
      }
    }
  },
  methods: {},
};
</script>
